module.exports = (
  $scope,
  $uibModalInstance,
  workflows,
  steps,
  currentStep
) ->

  $scope.workflows = workflows
  $scope.currentStep = currentStep

  $scope.getTargetWorkflowSteps = ( aWorkflow ) ->
    ( s[0] for k, s of steps when s[0].workflow is aWorkflow.id )

  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"
    return

  $scope.onStepSelected = ( step ) ->
    $uibModalInstance.close step
